import * as React from 'react'
import { PageIsUnavailable } from '../PageIsUnavailable'

export const TheNightlyPageIsUnavailable = () => {
    return <PageIsUnavailable />
}
